import React from 'react'

/**
 * Один тост — справа сверху, success/error.
 * Позиция и стили задаются контейнером (.toast-container).
 */
export default function Toast({ id, message, type = 'success' }) {
  return (
    <div
      key={id}
      className={`toast toast--${type}`}
      role="status"
      aria-live="polite"
    >
      {message}
    </div>
  )
}
